import settings from '@/settings'

const criarPix = (headers, payload) => {
  return fetch(`${settings.apiPayment}/apetrus/pix/`, {
    method: 'POST',
    body: JSON.stringify(payload),
    mode: 'cors',
    headers: headers
  })
}

const consultarPix = (headers, payload) => {
  let url = `${settings.apiPayment}/apetrus/pix/`
  if (payload) {
    const keys = Object.keys(payload)
    for (let i = 0; i < keys.length; i++) {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${keys[i]}=${payload[keys[i]]}`
    }
  }

  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    headers: headers
  })
}

export default {
  criarPix,
  consultarPix
}
